import React from "react"
import axios from 'axios';
import { AccountSearchForm } from './search/AccountSearchForm.jsx';
import { ErrorMessage } from './shared/ErrorMessage.jsx';
import { NewEsmAccountTips } from './tips/NewEsmAccountTips.jsx';
import I18n from 'i18n-js';
import './translations.js';

class RegistrantCreatePersonWizard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: 'person',
      hasMemberships: true,
      errorMessage: false,
      showSearchForm: false,
      formLoader: null,
      userData: '',
      usef: '',
      fei: '',
      ec: ''
    };
    this.handleAcountOptionChange = this.handleAcountOptionChange.bind(this);
    this.handleMembershipCheckboxChange = this.handleMembershipCheckboxChange.bind(this);
    this.checkUserMembership = this.checkUserMembership.bind(this);
    this.showSearchForm = this.showSearchForm.bind(this);
    this.goBackToPeople = this.goBackToPeople.bind(this);
    this.goBackFromSearchForm = this.goBackFromSearchForm.bind(this);
    this.acceptAlphanumeric = this.acceptAlphanumeric.bind(this);
    this.acceptNumbers = this.acceptNumbers.bind(this);
    I18n.locale = this.props.locale;

  }

  handleAcountOptionChange(e) {
    this.setState({ selectedOption: e.target.value });
  }

  handleMembershipCheckboxChange(e) {
    this.setState({ hasMemberships: !e.target.checked , errorMessage: ''});
  }

  goBackToPeople() {
    if (!this.state.formLoader) {
      if (this.props.createUserData.registrant) {
        window.location = "/registrants/" + this.props.createUserData.registrant.id +"/people";
      } else {
        window.location = "/";
      }
    }
  }

  goBackFromSearchForm() {
    this.setState({ showSearchForm: false, hasMemberships: true, errorMessage: '' });
  }

  updateExistingUserInfo(user_data) {
    if (user_data.already_exists) {
      var message = I18n.t("exhibitor.person_already_exists", { person: user_data.name, exhibitor: user_data.registrant_name });
      this.setState({ errorMessage: message });
    } else if (user_data.usef_valid && user_data.fei_valid && user_data.ec_valid) {
      this.setState({ 
        errorMessage: false,
        userData: user_data,
        usef: this.usef_membership_number.value,
        fei: this.fei_membership_number.value,
        ec: this.ec_membership_number.value
         })
      this.showSearchForm();
    } else {
      var message = "";
      if (!user_data.usef_valid) {
        message += I18n.t("exhibitor.ea_not_valid", { ea: "USEF" });
      }
      if (!user_data.fei_valid) {
        message += I18n.t("exhibitor.ea_not_valid", { ea: "FEI" });
      }
      if (!user_data.ec_valid) {
        message += I18n.t("exhibitor.ea_not_valid", { ea: "EC" });
      }
      this.setState({ errorMessage: message });
    }
    this.setState({ formLoader: null});
  }

  showSearchForm() {
    this.setState({ showSearchForm: true, formLoader: null });
  }

  acceptAlphanumeric(e) {
    const re = /[0-9a-zA-Z]+/g;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  }

  acceptNumbers(e) {
    const re = /[0-9]+/g;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  }

  checkUserMembership(e) {
    e.preventDefault();
    this.setState({ formLoader: "loader-box"});
    if (!this.state.hasMemberships) return this.showSearchForm();
    axios.post('/api/v1/equine_association/existing_user_bulk_check', {
      usef_membership_number: this.usef_membership_number.value,
      ec_membership_number: this.ec_membership_number.value,
      fei_membership_number: this.fei_membership_number.value
      })
      .then(response => this.updateExistingUserInfo(response.data))
      .catch(error => this.setState({ errorMessage: I18n.t("exhibitor.ea_try_none"), formLoader: null}));
  }

  render () {
    return (
      <div className="form-horizontal">
        {!this.state.showSearchForm ?
          <div>
            <h2> { I18n.t("exhibitor.create_person_header") }</h2>
            { !this.props.createUserData.registrant ?
              <NewEsmAccountTips/>
              : undefined
            }
            { this.state.errorMessage ? 
              <ErrorMessage message={this.state.errorMessage} />
              : undefined
            }
            <p>{ I18n.t("exhibitor.i_want_to_create_prompt") }</p>
            <form>
              <label className="radio-inline">
                <input type="radio" id="createOption1" value="person" 
                checked={this.state.selectedOption === 'person'}
                onChange={this.handleAcountOptionChange} />
                { I18n.t("person_label") }
              </label>
              <label className="radio-inline">
                <input type="radio" id="createOption2" value="company" 
                checked={this.state.selectedOption === 'company'}
                onChange={this.handleAcountOptionChange} />
                { I18n.t("company_label") }
              </label>
            </form>

            <p>{ I18n.t("exhibitor.they_have_memberships_prompt") }</p>
            <div className="outer-box">
              <div className={this.state.formLoader}>
                <div className={this.state.formLoader ? "loader" : ""}/>
                <form onSubmit={this.checkUserMembership}>
                  <div className="row">
                    <div className="control-group string optional usef">
                      <label className="string optional control-label">{ I18n.t("equine_association.usef") }</label>
                      <div className="controls">
                        <input className="string optional" type="text" onKeyPress={(e) => this.acceptAlphanumeric(e)} ref={input => this.usef_membership_number = input} disabled={!this.state.hasMemberships || this.state.formLoader}/>
                      </div>
                    </div>
                    <div className="control-group string optional fei">
                      <label className="string optional control-label">{ I18n.t("equine_association.fei") }</label>
                      <div className="controls">
                        <input className="string optional" type="text" onKeyPress={(e) => this.acceptNumbers(e)} ref={input => this.fei_membership_number = input} disabled={!this.state.hasMemberships || this.state.formLoader}/>
                      </div>
                    </div>
                    <div className="control-group string optional ec">
                      <label className="string optional control-label">{ I18n.t("equine_association.ec") }</label>
                      <div className="controls">
                        <input className="string optional" type="text" onKeyPress={(e) => this.acceptNumbers(e)} ref={input => this.ec_membership_number = input} disabled={!this.state.hasMemberships || this.state.formLoader}/>
                      </div>
                    </div>
                    <div className="control-group string optional none">
                      <label className="string optional control-label">{ I18n.t("none") }</label>
                      <div className="controls">
                        <input type="checkbox" disabled={this.state.formLoader} onChange={this.handleMembershipCheckboxChange}/>
                      </div>
                    </div>
                    <a className="btn btn-success" onClick={this.goBackToPeople} disabled={this.state.formLoader}>{ I18n.t('back_button_label') }</a>
                    <span> </span>
                    <input className="btn btn-success" type="submit" disabled={this.state.formLoader} value={ I18n.t('next_button_label') }/>
                  </div>
                </form>
              </div>
            </div>
          </div>
          :
          <AccountSearchForm type={this.state.selectedOption}
            createUserData={this.props.createUserData} 
            userData={this.state.userData}
            skipSearch={this.state.hasMemberships}
            goBack={this.goBackFromSearchForm}
            usef={this.state.usef}
            ec={this.state.ec}
            fei={this.state.fei}
            />
        }
      </div>
    );
  }
}

export default RegistrantCreatePersonWizard
